import { logError } from '@zg-rentals/log-error';
import { getAnalyticsErrorType } from '@zg-rentals/rentals-analytics';
import type { ZrmClickstreamLease, ZrmLeaseInfo } from './types';

export function getZrmLeaseInfo(lease: ZrmClickstreamLease = {}): ZrmLeaseInfo {
  try {
    const { status, type, id } = lease;

    return {
      zrm_lease_info: {
        lease_status_txt: status ? String(status) : null,
        lease_type_cd: type ? String(type) : null,
        lease_bundle_id: id ? Number(id) : null,
      },
    };
  } catch (error) {
    logError({ error, errorType: getAnalyticsErrorType('getZrmLeaseInfo'), context: { argumentPassed: lease } });

    return {
      zrm_lease_info: {
        lease_status_txt: null,
        lease_type_cd: null,
        lease_bundle_id: null,
      },
    };
  }
}
